"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseValleyBankPipelineStatusMetadata = exports.parseValleyBankArrangementGroup = exports.parseValleyBankAssignmentPreviewRRT = exports.parseValleyBankLoanAccountsWithCollateralAndStatsArray = exports.parseValleyBankPortfolioReceivableResponseTapeStats = exports.parseValleyBankLoanAccountWithCollateralAndStats = exports.parseValleyBankLoanAccountWithCollateralStatsArray = exports.parseValleyBankCustomers = exports.parseValleyBankCustomer = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const typeguards = __importStar(require("./typeguards"));
const parseValleyBankCustomer = (json) => {
    const customer = JSON.parse(json);
    (0, common_1.finleyAssert)(typeguards.isValleyBankCustomerWithRelationships(customer), 'Invalid Valley Bank Customer');
    return customer;
};
exports.parseValleyBankCustomer = parseValleyBankCustomer;
const parseValleyBankCustomers = (json) => {
    const customers = JSON.parse(json);
    (0, common_1.finleyAssert)(_.isArray(customers) &&
        _.every(customers, typeguards.isValleyBankCustomerWithRelationships), 'Invalid Valley Bank Customers');
    return customers;
};
exports.parseValleyBankCustomers = parseValleyBankCustomers;
const parseValleyBankLoanAccountWithCollateralStatsArray = (json) => {
    const loanAccounts = JSON.parse(json);
    (0, common_1.finleyAssert)(_.isArray(loanAccounts) &&
        _.every(loanAccounts, typeguards.isValleyBankLoanAccountWithCollateralStats), 'Invalid Valley Bank Loan Account w/ Collateral Stats');
    return loanAccounts;
};
exports.parseValleyBankLoanAccountWithCollateralStatsArray = parseValleyBankLoanAccountWithCollateralStatsArray;
const parseValleyBankLoanAccountWithCollateralAndStats = (json) => {
    const loanAccount = JSON.parse(json);
    (0, common_1.finleyAssert)(typeguards.isValleyBankLoanAccountWithCollateralAndStats(loanAccount), 'Invalid Valley Loan Account w/ Collateral and Stats');
    return loanAccount;
};
exports.parseValleyBankLoanAccountWithCollateralAndStats = parseValleyBankLoanAccountWithCollateralAndStats;
const parseValleyBankPortfolioReceivableResponseTapeStats = (json) => {
    const stats = JSON.parse(json);
    (0, common_1.finleyAssert)(typeguards.isValleyBankPortfolioReceivableResponseTapeStats(stats), 'Invalid Valley Loan Account w/ Collateral and Stats');
    return stats;
};
exports.parseValleyBankPortfolioReceivableResponseTapeStats = parseValleyBankPortfolioReceivableResponseTapeStats;
const parseValleyBankLoanAccountsWithCollateralAndStatsArray = (json) => {
    const loanAccounts = JSON.parse(json);
    (0, common_1.finleyAssert)(_.isArray(loanAccounts) &&
        _.every(loanAccounts, typeguards.isValleyBankLoanAccountWithCollateralAndStats), 'Invalid Valley Bank Loan Account w/ Collateral and Stats');
    return loanAccounts;
};
exports.parseValleyBankLoanAccountsWithCollateralAndStatsArray = parseValleyBankLoanAccountsWithCollateralAndStatsArray;
const parseValleyBankAssignmentPreviewRRT = (json) => {
    const response = JSON.parse(json);
    (0, common_1.finleyAssert)(_.isArray(response.rows) &&
        _.every(response.rows, typeguards.isFinleyValleyBankResponseTapeRow), 'Invalid Finley Valley Bank Response Row');
    (0, common_1.finleyAssert)(_.isArray(response.errors) &&
        _.every(response.errors, (e) => typeof e === 'string'), 'Invalid Finley Valley Bank Response Row Errors');
    return { rows: response.rows, errors: response.errors };
};
exports.parseValleyBankAssignmentPreviewRRT = parseValleyBankAssignmentPreviewRRT;
const parseValleyBankArrangementGroup = (json) => {
    const arrangementGroup = JSON.parse(json);
    (0, common_1.finleyAssert)(typeguards.isValleyBankArrangementGroup(arrangementGroup), 'Invalid Valley Bank Loan Account w/ Collateral and Stats');
    return arrangementGroup;
};
exports.parseValleyBankArrangementGroup = parseValleyBankArrangementGroup;
const parseValleyBankPipelineStatusMetadata = (json) => {
    const metadata = JSON.parse(json);
    (0, common_1.finleyAssert)(typeguards.isValleyBankPipelineStatusMetadata(metadata), 'Invalid Valley Bank Pipeline Status Metadata');
    return metadata;
};
exports.parseValleyBankPipelineStatusMetadata = parseValleyBankPipelineStatusMetadata;
//# sourceMappingURL=parse.js.map